import {safeUpdateStyle, withElement} from "../Utility/html";
import {HTML_IDS, ZINDEXES} from "./constants";

// Called after the chat window is opened
export function fixZIndexes() {
  safeUpdateStyle(HTML_IDS.googleMerchantWidget, { zIndex: ZINDEXES.slightlyElevated });
}
